/* @flow */

// eslint-disable-next-line import/prefer-default-export
export const CatalogTypes = {
  dev: 'dev',
  prod: 'prod',
};

export type CatalogType = $Values<typeof CatalogTypes>;
